import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { store } from "shared/api/firebase";

type Params = {
  keyImage: string;
  image: File;
};

export const saveBroadcastImage = async ({ keyImage, image }: Params) => {
  // References for images
  const path = `broadcasts/${keyImage}`;
  const imgStorageRef = ref(store, path);

  try {
    await uploadBytes(imgStorageRef, image as File);

    return await getDownloadURL(imgStorageRef);
  } catch (error) {
    console.error("Error saving broadcast image:", error);
    throw error;
  }
};
